export default class ServerErrorException extends Error {
    constructor(message){
        super(message)
        this.name = this.constructor.name
    }
}